import { memo } from 'preact/compat';

// Components.
import { Region } from './Region';

export type RegionsProps = {
	regions: SingleRegion[];
};

/**
 * Regions component. Renders state paths.
 * Memo'd to reduce re-renders.
 *
 * @param {Object} props
 * @param {Array}  props.regions - array of regions with path data
 * @return {*} jsx
 */
export const Regions = memo( ( { regions }: RegionsProps ) => {
	return (
		<>
			{ regions.map( ( region ) => {
				if ( ! region || ! region.id || ! region.d ) {
					return null;
				}

				return (
					<Region
						key={ `region-${ region.id }` }
						region={ region }
						pathAttributes={ {
							className: 'str-maps__state region',
						} }
					/>
				);
			} ) }
		</>
	);
} );
